import { render, staticRenderFns } from "./PublishPages.vue?vue&type=template&id=59a0e0d0&scoped=true"
import script from "./PublishPages.vue?vue&type=script&lang=js"
export * from "./PublishPages.vue?vue&type=script&lang=js"
import style0 from "./PublishPages.vue?vue&type=style&index=0&id=59a0e0d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a0e0d0",
  null
  
)

export default component.exports